import React from "react"
import "./App.css"
import { createGlobalStyle } from "styled-components"
import ScrewModel from "./components/ScrewModel"
import CategoryNavigation from "./components/CategoryNavigation"
import { PartsProvider } from "./provider/PartsContext"
import PageHeader from "./layout/PageHeader"
import InfoPanel from "./components/InfoPanel"
const GlobalStyle = createGlobalStyle`
  :root {
    --handle-size: 1.5rem;
    --img-gap: .1rem;
  }
  html {
    height: 100%;
  }
  body {
    margin: 0;
    height: 100%;
  }
  canvas {
    width: 100%;
    height: 100%;
    display: block;
  }  `

const App = () => {
  return (
    <>
      <GlobalStyle />
      <PageHeader />
      <PartsProvider>
        {/* <InfoPanel /> */}
        <ScrewModel />
        <CategoryNavigation />
      </PartsProvider>
    </>
  )
}

export default App
